import { ServerRecord } from '../data/inventoryData';

export interface SiteGroup {
  name: string;
  Latitude: number;
  Longitude: number;
  physical: number;
  virtual: number;
  gpu: number;
  servers: ServerRecord[];
}

export type SiteMap = Record<string, SiteGroup>;

function normalizeSiteName(value: string): string {
  const raw = String(value || '').trim();
  const key = raw.toLowerCase().replace(/\s+/g, ' ');
  if (key === 'aberdeen' || key === 'aberdeen, north carolina, usa')
    return 'Aberdeen, North Carolina, USA';
  if (key.includes('frankfort')) return 'Frankfort, Kentucky, USA';
  return raw;
}

export function hasValidCoords(lat: unknown, lng: unknown): boolean {
  return (
    typeof lat === 'number' &&
    typeof lng === 'number' &&
    Number.isFinite(lat) &&
    Number.isFinite(lng)
  );
}

export function groupBySite(data: ServerRecord[]): SiteMap {
  const sites: SiteMap = {};
  data.forEach((r) => {
    const siteName = normalizeSiteName(r.site);
    if (!sites[siteName]) {
      sites[siteName] = {
        name: siteName,
        Latitude: NaN,
        Longitude: NaN,
        physical: 0,
        virtual: 0,
        gpu: 0,
        servers: [],
      };
    }
    // Some records are missing Latitude/Longitude entirely; only take
    // coordinates from a record once we find a valid pair for this site.
    if (
      !hasValidCoords(sites[siteName].Latitude, sites[siteName].Longitude) &&
      hasValidCoords(r.Latitude, r.Longitude)
    ) {
      sites[siteName].Latitude = r.Latitude;
      sites[siteName].Longitude = r.Longitude;
    }
    if (r.serverType.toUpperCase().includes('PHYSICAL')) {
      sites[siteName].physical += 1;
    } else {
      sites[siteName].virtual += 1;
    }
    if (r.GPUCount && Number(r.GPUCount) > 0) sites[siteName].gpu += 1;
    sites[siteName].servers.push({ ...r, site: siteName });
  });
  return sites;
}

export function markerType(site: SiteGroup): 'gpu' | 'physical' | 'vm' {
  if (site.gpu > 0) return 'gpu';
  if (site.physical > 0) return 'physical';
  return 'vm';
}
